import { NgModule } from "@angular/core";
import { SpinnerComponent } from "@/shared/components/spinner/spinner.component";
import { LottieModule } from "ngx-lottie";

export function playerFactory(): any {
  return import('lottie-web');
}

@NgModule({
  declarations: [SpinnerComponent],
  exports: [SpinnerComponent],
  imports: [
    LottieModule,
    LottieModule.forRoot({ player: playerFactory }),
  ],
})

export class SpinnerModule {}
